<template>
  <section class="section is-title-bar">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <ul class="title">
            <li v-for="(title,index) in titleStack" :key="index">
              <template v-if="Array.isArray(title)">
                <router-link :to="{name: title[1]}">
                  {{title[0]}}
                </router-link>
              </template>
              <template v-else>
              {{ title }}
              </template>
            </li>
            <li></li>
          </ul>
        </div>
      </div>
      <div class="level-right">
          <slot></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TitleBar',
  props: {
    titleStack: {
      type: Array,
      default: () => []
    }
  }
}
</script>
